import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'jb-header-skeleton',
  templateUrl: './header-skeleton.component.html',
  styleUrls: ['./header-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderSkeletonComponent {
  @Input() hideSuperGlobalNav = false;
}
